<script lang="ts">
	//UI
	import ComponentCover from "@hitit/hub/src/v7/components/common/ComponentCover.svelte";
	import ComponentLoading from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte";
	import { Card, DefaultSwitch } from "@hitit/new_ui";
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import SaveIcon from "@hitit/hub/src/assets/Icons/Save.png";
	import { api, notifications, t } from "@hitit/hub/src/stores";
	import StoreNameValue from "@hitit/hub/src/v7/components/store/StoreNameValue.svelte";
	//Utils
	//Types
	import type { GeneralSettingDTO } from "@hitit/api";
	//Props
	export let generalSetting: GeneralSettingDTO | null = null;
	export let coverStatus = false;
	export let editmode = false;
	export let editable = false;
	export let storeId = "";
	//Constants
	const message = "일반 설정 저장 도중 문제가 발생하였습니다.";
	//Variables
	let vibrationBellAvailable: boolean | undefined = false;
	let loading = false;
	let error = "";

	//Functions
	async function actionHandler() {
		if (!editmode) {
			editmode = true;
			return;
		}

		try {
			error = "";
			loading = true;
			// await $api.setGeneralSetting(storeId, {
			// 	pagerEnabled: vibrationBellAvailable,
			// });
			alert('아직 사용할 수 없는 기능입니다. 서버에 저장되지 않습니다.')
			editmode = false;
		} catch (error) {
			console.log(error);
			notifications.append("ERROR", message, "", undefined, "WARNING");
		} finally {
			loading = false;
		}
	}

	function switchChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		vibrationBellAvailable = target.checked ? true : false;
	}
	//Do
	$: vibrationBellAvailable = generalSetting?.pagerEnabled;
</script>

<div class="root-wrapper">
	<Card noPadding>
		<div class="container" t-id="GeneralSettingWidget">
			{#if coverStatus}
				<ComponentCover />
			{/if}
			{#if loading}
				<ComponentLoading coverMode />
			{/if}
			{#if editable}
				<div class="action" on:click={actionHandler}>
					<span>{editmode ? $t("global.done") : $t("global.edit")}</span>
					<img
						src={editmode ? SaveIcon : EditIcon}
						alt={editmode ? "save" : "edit"}
					/>
				</div>
			{/if}
			<p class="title">{$t("hub.store.generalsettings.generalsettings")}</p>
			{#if editmode && error}
				<p class="error">{error}</p>
			{/if}
			<StoreNameValue
				name={$t("hub.store.generalsettings.use_vibrating_bell")}
				editmode={editmode}
				value={vibrationBellAvailable === true
					? $t("hub.store.widget.cashreceipt.enabled")
					: $t("hub.store.widget.cashreceipt.disabled")}
			>
				<div slot="input" class="lock-box">
					<DefaultSwitch
						checked={vibrationBellAvailable === true}
						on:change={switchChangeHandler}
					/>
				</div>
			</StoreNameValue>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.root-wrapper {
		width: 100%;
	}
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		gap: 20px;
		.title {
			font-size: 1.25rem;
			font-weight: 600;
			color: #46474b;
		}
		.action {
			display: flex;
			gap: 10px;
			align-items: center;
			position: absolute;
			right: 10px;
			top: 10px;
			color: #6d6f76;
			font-weight: 500;

			&:hover {
				cursor: pointer;
			}
			img {
				width: 24px;
				height: 24px;
				object-fit: contain;
			}
		}

		.input {
			flex-grow: 1;
			height: 31px;
			color: #46474b;
			font-size: 1rem;
		}
	}
	@include DesktopSize {
		.root-wrapper {
			max-height: 195px;
		}
		.container {
			padding: 30px;
			gap: 30px;
			.title {
				font-size: 2.125rem;
			}
			.action {
				top: 20px;
				right: 20px;
				font-size: 1.25rem;
			}
			.input {
				height: 40px;
				width: 100%;
				max-width: calc(100% - 40px);
				font-size: 1.25rem;
			}
		}
	}
</style>
